import AuthSlice from "../features/auth/auth-slice";
import UsersSlice from "../features/users/users-slice";
import UserSlice from "./user/user-slice";
import TrainersSlice from "./trainers/trainers-slice";
import TrainerSlice from "./trainer/trainer-slice";
import ExercisesSlice from "./exercises/exercises-slice";
import ExerciseSlice from "./exercise/exercise-slice";
import AltExerciseSlice from "./exercise/alt-exercises-slice";
import TrainingProgramsSlice from "./training-programs/training-programs-slice";
import TrainingProgramSlice from "./training-program/training-program-slice";
import WorkoutsSlice from "./workouts/workouts-slice";
import WorkoutSlice from "./workout/workout-slice";
import VodsSlice from "./vods/vods-slice";
import VodSlice from "./vod/vod-slice";
import RecipesSlice from "./recipes/recipes-slice";
import RecipeSlice from "./recipe/recipe-slice";
import UserTrainingProgramsSlice from "./user/training-programs/training-programs-slice";
import DashboardStatsSlice from "./dashboard/stats/stats-slice";
import DashboardActiveUsersSlice from "./dashboard/active-users/active-users-slice";
import DashboardRevenuesSaga from "./dashboard/revenues/revenues-slice";

const reducers = {
  auth: AuthSlice,
  users: UsersSlice,
  user: UserSlice,
  trainers: TrainersSlice,
  trainer: TrainerSlice,
  exercises: ExercisesSlice,
  exercise: ExerciseSlice,
  trainingPrograms: TrainingProgramsSlice,
  trainingProgram: TrainingProgramSlice,
  workouts: WorkoutsSlice,
  workout: WorkoutSlice,
  vods: VodsSlice,
  vod: VodSlice,
  recipes: RecipesSlice,
  recipe: RecipeSlice,
  userTrainingPrograms: UserTrainingProgramsSlice,
  dashboardStats: DashboardStatsSlice,
  dashboardActiveUsers: DashboardActiveUsersSlice,
  dashboardRevenues: DashboardRevenuesSaga,
  altExercises: AltExerciseSlice,
};

export default reducers;
